import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpService } from '../http/http.service';
import { Channel } from "src/app/models/Channel";
import { ApiUrl } from "src/app/models/ApiUrl";
@Injectable({
  providedIn: "root",
})
export class ChannelService {
  constructor(private http: HttpService) { }

    /***
   * Get channel by ID
   */
     public GetChannelbyID(request : any) : Observable<Channel>{
      return this.http.post<Channel>('/api/Channel/GetChannelByID',request);
    }

  /***
   * Get channel by UserID
   */
  public GetChannel() : Observable<any>{
    return this.http.post<any>('/api/Channel/GetChannel');
  }

  /***
   *Submit Channel
   */
  public Submit(payload : Channel): Observable<any>{    
    return this.http.post<any>('/api/Channel/Submit',payload);
  }

  public Delete(ListID : any) : Observable<{ Message : ""}>{
    return this.http.post<any>('/api/Channel/Delete',JSON.stringify(ListID));
  }

public verifyChannel(ID: string) {
    return this.http.get<any>(ApiUrl.CHANNEL_VERIFY, [
      { key: 'ID', value: ID }
    ]);
  }

}